
import React from 'react';
import {Helmet,HelmetProvider} from 'react-helmet-async';
import SignatureCanvas from 'react-signature-canvas';
import {ComponentPopup} from '../components/Popup';
import {Box,Button,TextButton,Select} from '../components/Input';
import {LoadGraphic} from './Common';
import Measure from 'react-measure';
import PropTypes from 'prop-types';
import moment from 'moment';
import u from '../utilities/Utilities';
import "../styles/print-page-layout.scss";

export default class PrintPageLayout extends React.Component{

    r={};

    state={
        instantiated:false,
    };

    componentDidMount=()=>{
        this.setState({
            instantiated:true
        });
    }

    showPopup=(show)=>{
        console.log("showPopup",show);
        this.r['popup'].show(show);
    }

    setPopupComponent=(component)=>{
        this.r['popup'].setComponent(component);
    }

    render(){
        if(!this.state.instantiated){
            return (<div/>)
        }

        return(
            <HelmetProvider>
                <div className='print-page-main-container'>
                    <Helmet>
                        <title>{this.props.title}</title>
                        <meta name="viewport" content="width=device-width,initial-scale=1"/>
                        <meta name="viewport" content="height=device-height,initial-scale=1"/>
                    </Helmet>
                    
                    <div className="print-pages-container" style={this.props.style}>
                        {this.props.children}
                    </div>

                    <div id="tool-tip" className="tool-tip no-print">
                        <div id="tool-tip-text" className="tool-tip-text"/>
                        <div className="tool-tip-triangle"/>
                    </div>

                    <ComponentPopup ref={(ref)=>{this.r["popup"]=ref}}/>
                </div>
            </HelmetProvider>
        );
    }
};
PrintPageLayout.propTypes={
    title:PropTypes.string,
};

export class SignatureStamp extends React.Component{

    onClick=()=>{
        if(!this.props.enabled){
            return false;
        }
        this.props.onClick();
    }

    render=()=>{
        const {content,enabled}=this.props;
        return(
             <div className={'signature-stamp-container' + ((enabled) ? " enabled" : "")}>
                {
                    (content?.sign)
                        ?
                        <div onClick={this.onClick} className='signature-stamp'>
                            <img src={content.sign}/>
                            <div className='signature-stamp-details'>
                                <div><b>{content.signBy}</b></div>
                                <div><b>{moment(content.signOn).format("DD MMM YY - h:mma")}</b></div>
                            </div>
                        </div>
                        :
                        <div onClick={this.onClick} className='signature-stamp-empty'>
                            <div className='no-print'>Click to Sign</div>
                            <div className='print-only'>No Signature</div>
                        </div>
                }
             </div>
        )
    }
}

export class SignatureInput extends React.Component{
    r={};

    state={
        loading:false,
        loadText:"",
        dimensions:{}
    }

    onValidate=async ()=>{
        const keys=["signBy"];
        let data={};
        for(var i=0; i<keys.length; i++){
            const current=this.r[keys[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
            data[keys[i]]=current.value;
        }

        if(this.r['sign'].isEmpty()){
            this.setState({error:"Field: Signature is required"});
            return 0;
        }

        this.setState({loading:true,loadText:"Uploading..."});

        const signatureURL = this.r['sign'].getTrimmedCanvas().toDataURL("image/png");

        var arr = signatureURL.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }

        const signature = new File([u8arr], "incident-signature", {type:mime});

        try{
            const response=await u.uploadAsync({
                file:signature,
                filename:"incident-signature.png",
            });
            data.sign = response.data;
            data.signOn = moment().format("YYYY-MM-DD HH:mm:ss");
            console.log("signature",data);
            this.props.onComplete(data);
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({loading:false,error:error});
        }
    }

    render=()=>{
        const {content,onCancel}=this.props;
        const {dimensions}=this.state;

        return (
            <div className='signature-input-container'>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <h3 style={{marginTop:"0"}}>Please Sign Below</h3>
                {
                    (this.props.staffOptions)
                        ?
                        <div>
                            <Select ref={(ref)=>{this.r['signBy']=ref}}
                                    label="Name"
                                    values={{options:this.props.staffOptions}}
                                    rules={{
                                        required:true,
                                    }}
                                    />
                        </div>
                        :
                        <div>
                            <Box ref={(ref)=>{this.r['signBy']=ref}}
                                label="Name"
                                rules={{
                                    required:true,
                                    placeholder:"Name (ID if applicable)",
                                    defaultValue:content.name
                                }}/>
                        </div>
                }
                
                <Measure bounds onResize={contentRect => {this.setState({ dimensions: contentRect.bounds })}}>
                {
                    ({measureRef})=>
                        (
                            <div ref={measureRef} className="signature-input">
                                <div className='signature-bg'>
                                    <div style={{opacity:"0.5"}}><b>SIGN HERE</b></div>
                                </div>
                                <div className='signature'>
                                    <SignatureCanvas ref={(ref)=>{this.r['sign']=ref}}
                                                        penColor='blue'
                                                        canvasProps={{
                                                            width: dimensions.width,
                                                            height: 200,
                                                            willreadfrequently:"true",
                                                        }}
                                                        />
                                </div>
                            </div>
                        )
                }
                </Measure>
                <TextButton style={{margin:"5px auto 0 auto",fontSize:"14px"}} onClick={()=>{this.r['sign'].clear()}}>Clear</TextButton>
                <div style={{margin:"10px auto"}}>
                    <div className='page-error'>{this.state.error}</div>
                    <Button onClick={onCancel}>Cancel</Button>   
                    <Button onClick={this.onValidate}>Confirm</Button>
                </div>
            </div>
        )
    }
}